import {ChargingStationsResponse} from "./APITypes";

export const getInitialChargingStations = () =>
  ({
    operator: {
      placesCount: 209,
      operatorId: 7429489,
      operatorName: "WVV",
      amountStations: 209,
      amountIdentifications: 3352,
      amountUsers: 2684,
      operatorPlaces: [
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E621073902*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E621073902*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2015-39-L-010",
          description: "Im Parkhaus hinter der Schranke",
          address: {
            street: "Rüdigerstr. 3",
            city: "Würzburg",
            zipCode: "97070",
          },
          behindBarrier: true,
          shortcode: "skarh",
          lat: 49.795855,
          lon: 9.937994,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E897826783*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E897826783*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0629653",
          description: "",
          address: {
            street: "Sinnaustraße 14",
            city: "Bad Brückenau",
            zipCode: "97769",
          },
          shortcode: null,
          lat: 50.308301,
          lon: 9.790564,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E315507325*1",
              status: "LOADING",
              isReady: false,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E315507325*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0255536",
          description:
            "Einfahrt Parkhaus gegenüber Karmelitenstraße 17;  1. UG, Zugang Unterer Markt bei den Hauptkassen",
          address: {
            street: "Karmelitenstraße 30",
            city: "Würzburg",
            zipCode: "97070",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.794061,
          lon: 9.927645,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E037154674*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E037154674*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2016-38-L-002",
          description: "",
          address: {
            street: "Magdalene-Schoch-Straße 5",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: "tfskg",
          lat: 49.7868,
          lon: 9.967915,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E981538369*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E981538369*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "BAU_2016-42-T-001",
          description: null,
          address: {
            street: "Fahrmannstraße 4",
            city: "Zell am Main",
            zipCode: "97299",
          },
          shortcode: "xeyeg",
          lat: 49.813497,
          lon: 9.87119,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E384593202*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E384593202*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2017-22-T-001",
          description: null,
          address: {
            street: "Hofstraße 6",
            city: "Rimpar",
            zipCode: "97222",
          },
          shortcode: "sfkvg",
          lat: 49.856421,
          lon: 9.957507,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E831059435*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E831059435*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "BAU_2017-31-T-002",
          description: "",
          address: {
            street: "Haugerpfarrgasse 14",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: "uxsme",
          lat: 49.797688,
          lon: 9.935668,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E047056345*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E047056345*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2017-8-L-004",
          description: "Gegenüber Hausnummer 88",
          address: {
            street: "Rottendorfer Straße 79",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: "pctgh",
          lat: 49.790634,
          lon: 9.972373,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E843904326*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E843904326*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "BAU_2017-8-L-007",
          description: null,
          address: {
            street: "Rottendorferstraße 59",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: "GENERATED_d767347c-bfbe-4a45-af08-b9bec3b1ec2f",
          lat: 49.790932,
          lon: 9.964133,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E089305439*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E089305439*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2017-31-T-001",
          description: "",
          address: {
            street: "Pleicherschulgasse 1",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: "vgmch",
          lat: 49.796615,
          lon: 9.927154,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E000461460*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E000461460*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332120",
          description: "D-97070 Würzburg - Pleicherschulgasse 1",
          address: {
            street: "Pleicherschulgasse 1",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: null,
          lat: 49.796549,
          lon: 9.927097,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E564688541*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E564688541*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0629658",
          description: "Parkplatz",
          address: {
            street: "Ernst-Putz-Straße 4",
            city: "Bad Brückenau",
            zipCode: "97769",
          },
          shortcode: null,
          lat: 50.30863,
          lon: 9.786022,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E449690869*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E449690869*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "BAU_2018-23-T-001",
          description: null,
          address: {
            street: "Wallgasse",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: "eypdg",
          lat: 49.799547,
          lon: 9.937001,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E351414455*1",
              status: "LOADING",
              isReady: false,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E351414455*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "BAU_2018-23-T-002",
          description: null,
          address: {
            street: "Wallgasse",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: "mdtng",
          lat: 49.799547,
          lon: 9.937001,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E403289256*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E403289256*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_808829001190_(1437824538)",
          description: "hinter Torbogen links",
          address: {
            street: "Josef-Schneider-Str. 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: "gyd",
          lat: 49.800738,
          lon: 9.954184,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Universitätsklinikum Würzburg",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E945659237*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E945659237*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_808829001127_(1420246384)",
          description: null,
          address: {
            street: "Moritzberg 1",
            city: "Rottendorf",
            zipCode: "97228",
          },
          shortcode: "fdf",
          lat: 49.78721,
          lon: 10.031182,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E121896725*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E121896725*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_808829001160_(1420246367)",
          description: null,
          address: {
            street: "Moritzberg 1",
            city: "Rottendorf",
            zipCode: "97228",
          },
          shortcode: "qqd",
          lat: 49.78721,
          lon: 10.031182,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E069542799*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E069542799*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_808829001385_(1437824546)",
          description: "Parkhaus",
          address: {
            street: "Oberdürrbacher Straße 4",
            city: "Würzburg",
            zipCode: "97080",
          },
          behindBarrier: true,
          shortcode: "rde",
          lat: 49.807396,
          lon: 9.955986,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Universitätsklinikum Würzburg",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E599345857*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E599345857*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "BAU_2019-10-T-001",
          description: null,
          address: {
            street: "Am Golfplatz 2",
            city: "Würzburg",
            zipCode: "97084",
          },
          shortcode: "gtwuf",
          lat: 49.745203,
          lon: 9.938122,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E070081324*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E070081324*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2019-45-T-005",
          description: null,
          address: {
            street: "Virchowstraße 6",
            city: "Würzburg",
            zipCode: "97072",
          },
          shortcode: "fgchk",
          lat: 49.78493622067565,
          lon: 9.932548635440083,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E697260588*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E697260588*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2020-25-T-001",
          description: null,
          address: {
            street: "Turmgasse 9",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: "maenk",
          lat: 49.798171,
          lon: 9.926057,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E158640291*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E158640291*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2019-45-T-004",
          description: null,
          address: {
            street: "Platenstraße 12",
            city: "Würzburg",
            zipCode: "97072",
          },
          shortcode: "fmnyg",
          lat: 49.779553,
          lon: 9.934887,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E721275365*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E721275365*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2020-5-T-002",
          description: "",
          address: {
            street: "Residenzplatz",
            city: "Würzburg",
            zipCode: "97070",
          },
          behindBarrier: true,
          shortcode: "exxcg",
          lat: 49.792821,
          lon: 9.936597,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E179551533*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E179551533*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2019-45-T-007",
          description: null,
          address: {
            street: "Leightonstraße 3",
            city: "Würburg",
            zipCode: "97074",
          },
          shortcode: "ynvdf",
          lat: 49.786807,
          lon: 9.980283,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "Place 1",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2_CABLE",
              evseId: "DE*BDO*E1234567*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2_CABLE",
              evseId: "DE*BDO*E1234567*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_EMH3",
          description: null,
          address: {
            street: "Josef-Schneider Straße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: "bpt",
          lat: 49.80588,
          lon: 9.95884,
          status: "LOADING",
          published: false,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Universitätsklinikum Würzburg",
        },
        {
          name: "Place 2",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E11122266*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E11122266*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2020-01-L-009",
          description: null,
          address: {
            street: "Nürnberger Straße 126",
            city: "Würzburg",
            zipCode: "97076",
          },
          shortcode: "ncywf",
          lat: 49.795467,
          lon: 10.000438,
          status: "LOADING",
          published: false,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie E-Ladestation Grombühl UKW III",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E624371378*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E624371378*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_3P443500078_WVV",
          description: "hinter Torbogen geradeaus rechts",
          address: {
            street: "Josef-Schneider-Straße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: "ssn",
          lat: 49.800181,
          lon: 9.957045,
          status: "LOADING",
          published: false,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Universitätsklinikum Würzburg",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E056881802*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E056881802*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0085371",
          description: "",
          address: {
            street: "Nigglweg 5",
            city: "Würzburg",
            zipCode: "97082",
          },
          behindBarrier: true,
          shortcode: "cmm",
          lat: 49.794969,
          lon: 9.919357,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E633749084*1",
              status: "LOADING",
              isReady: false,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E633749084*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0085370",
          description: null,
          address: {
            street: "Frankfurter Straße 87",
            city: "Würzburg",
            zipCode: "97082",
          },
          shortcode: "lcc",
          lat: 49.793915,
          lon: 9.893593,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E860514571*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E860514571*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
          ],
          serviceTag: "ALP_21BZ1059B",
          description:
            "Ladepunkt 2 (rechts) ist ausschließlich den E-Taxen vorbehalten.",
          address: {
            street: "Salvatorstraße 26",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: "thi",
          lat: 49.791594,
          lon: 9.953112,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E996708301*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E996708301*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_3P441200535",
          description: "",
          address: {
            street: "Margarete-Höppel-Platz",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: "zwv",
          lat: 49.80424947806713,
          lon: 9.940319962871802,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E823335318*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E823335318*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_3P441200523",
          description: "",
          address: {
            street: "Margarete-Höppel-Platz",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: "vnw",
          lat: 49.8042495,
          lon: 9.94032,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E440383291*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0411258",
          description: "U2/170",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E541459671*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413798",
          description: "U3/216",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E091639292*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413894",
          description: "U2/178",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "eye",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E011789821*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413879",
          description: "U2/193",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "flv",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E056541382*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413890",
          description: "U2/201",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "oyy",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E510445842*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413861",
          description: "U2/192",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "fer",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E646006206*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413808",
          description: "U2/202",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "vxe",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E596770945*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413882",
          description: "U2/203",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "plj",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E063248407*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413889",
          description: "U2/204",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "wbd",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E122763638*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413888",
          description: "U2/197",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "eor",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E732832417*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413874",
          description: "U2/195",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "eur",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E346776969*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413880",
          description: "U2/194",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "gho",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E755472739*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413903",
          description: "U2/172",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "pfj",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br>  E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E531787131*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413899",
          description: "U2/174",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "ykm",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E423455322*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413856",
          description: "U2/2",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "pne",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E673221273*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413892",
          description: "U2/1",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "ugg",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E806440904*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413811",
          description: "U2/198",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "zqf",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E637971410*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413872",
          description: "U2/175",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "ycs",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E084811504*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413893",
          description: "U2/176",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "ger",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E002336603*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413875",
          description: "U2/177",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "crn",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E145299642*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413901",
          description: "U2/171",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "mga",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E639371722*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413895",
          description: "U2/173",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "cur",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E486009294*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413845",
          description: "U2/196",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "lse",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E852093809*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413985",
          description: "U3/193",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "xuo",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E164835949*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413976",
          description: "U3/192",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "nvf",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E654542982*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413988",
          description: "U3/191",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "gtj",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E703938401*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413968",
          description: "U3/190",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "lnd",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E807542592*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413983",
          description: "U3/189",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "erb",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E052832728*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413994",
          description: "U3/186",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "ijf",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E094190977*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413966",
          description: "U3/185",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "vbo",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E828197630*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413891",
          description: "U3/2",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "wgk",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E732605318*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413999",
          description: "U3/1",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "qdj",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E835779667*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413971",
          description: "U3/187",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "hhw",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E475146654**1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413958",
          description: "U3/206",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "fof",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E106873552*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413959",
          description: "U3/207",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "flg",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E259928874*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413973",
          description: "U3/208",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "fti",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E473322129*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413977",
          description: "U3/209",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "myf",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E589499517*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413961",
          description: "U3/210",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "pvw",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E997482924*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413989",
          description: "U3/211",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "adb",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E334442837*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413963",
          description: "U3/212",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "kbh",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E730398306*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413996",
          description: "U3/213",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "gmv",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E841985160*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413995",
          description: "U3/215",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "gkx",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br>  E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E915853095*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413984",
          description: "U3/218",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "ewx",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E967310474*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413975",
          description: "U3/217",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "uli",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E714132084*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413896",
          description: "U2/199",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "jrg",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E104475588*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0413964",
          description: "U3/188",
          address: {
            street: "Von-Knoeringen-Straße 19",
            city: "München",
            zipCode: "81737",
          },
          behindBarrier: true,
          shortcode: "uzj",
          lat: 48.099085,
          lon: 11.646353,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "SVG Würzburger Stadtverkehrs-GmbH",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E624958224*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E624958224*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_3P441210214201",
          description: null,
          address: {
            street: "Albert-Schweitzer-Straße 10",
            city: "Höchberg",
            zipCode: "97204",
          },
          shortcode: null,
          lat: 49.789378,
          lon: 9.885107,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E237502750*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E237502750*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_3P441210229970",
          description: null,
          address: {
            street: "Albrecht-Dürer-Straße 104",
            city: "Höchberg",
            zipCode: "97204",
          },
          shortcode: null,
          lat: 49.79094,
          lon: 9.887682,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E333941591*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E333941591*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_22BZ2010A",
          description: null,
          address: {
            street: "Einsteinstraße 1",
            city: "Höchberg",
            zipCode: "97204",
          },
          shortcode: null,
          lat: 49.772660571203645,
          lon: 9.871018463961597,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E635754193*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E635754193*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10314450",
          description: null,
          address: {
            street: "Straßburger Ring",
            city: "Würzburg",
            zipCode: "97084",
          },
          shortcode: null,
          lat: 49.750871,
          lon: 9.957922,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E368213050*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E368213050*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10314446",
          description: null,
          address: {
            street: "Straßburger Ring",
            city: "Würzburg",
            zipCode: "97084",
          },
          shortcode: null,
          lat: 49.750871,
          lon: 9.957922,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E480543842*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E480543842*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10314448",
          description: "",
          address: {
            street: "Danziger Straße 1",
            city: "Würzburg",
            zipCode: "97072",
          },
          shortcode: null,
          lat: 49.777909,
          lon: 9.936588,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E636854151*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E636854151*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10314447",
          description: null,
          address: {
            street: "Am Ostbahnhof",
            city: "Würzburg",
            zipCode: "97084",
          },
          shortcode: null,
          lat: 49.761547,
          lon: 9.953635,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E159902666*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E159902666*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10312244",
          description: null,
          address: {
            street: "Am Ostbahnhof",
            city: "Würzburg",
            zipCode: "97084",
          },
          shortcode: null,
          lat: 49.76154,
          lon: 9.953691,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E493926816*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E493926816*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10313634",
          description: "Parkplatz am Zollhäusle",
          address: {
            street: "Jahnstraße",
            city: "Sommerhausen",
            zipCode: "97286",
          },
          shortcode: null,
          lat: 49.7085,
          lon: 10.023605,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E725068120*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E725068120*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0414675",
          description: null,
          address: {
            street: "Veitshöchheimer Straße 5A",
            city: "Würzburg",
            zipCode: "97080",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.802978,
          lon: 9.920502,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E598429949*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E598429949*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0414668",
          description: null,
          address: {
            street: "Veitshöchheimer Straße 5A",
            city: "Würzburg",
            zipCode: "97080",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.802978,
          lon: 9.920502,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E767210656*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E767210656*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0414685",
          description: null,
          address: {
            street: "Veitshöchheimer Straße 5A",
            city: "Würzburg",
            zipCode: "97080",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.802978,
          lon: 9.920502,
          status: "LOADING",
          published: true,
          accessibilityType: "PAYINGPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E318480553*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E318480553*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10313633",
          description: null,
          address: {
            street: "Neutorstraße 3",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: null,
          lat: 49.798293,
          lon: 9.939207,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E086789088*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E086789088*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10312237",
          description: null,
          address: {
            street: "Erwin-Wolf-Platz 1",
            city: "Würzburg",
            zipCode: "97078",
          },
          shortcode: null,
          lat: 49.819984,
          lon: 9.964604,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E815955040*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E815955040*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10314449",
          description: null,
          address: {
            street: "Herrnhofstraße 14",
            city: "Würzburg",
            zipCode: "97076",
          },
          shortcode: null,
          lat: 49.810509,
          lon: 9.985893,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E259135477*1",
              status: "LOADING",
              isReady: false,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E259135477*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10312243",
          description: null,
          address: {
            street: "Brettreichstraße 12",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.781673,
          lon: 9.948142,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E149342065*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E149342065*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10312239",
          description: null,
          address: {
            street: "Brettreichstraße 12",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.781738,
          lon: 9.948026,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E891549473*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E891549473*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10312245",
          description: null,
          address: {
            street: "Seuffertstraße 16",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.784155,
          lon: 9.945319,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E402902847*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E402902847*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10308373",
          description: null,
          address: {
            street: "Steinstraße 7",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: null,
          lat: 49.802583,
          lon: 9.924672,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: [],
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E346232752*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E346232752*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10263642",
          description: "",
          address: {
            street: "Sonnenstraße 8",
            city: "Würzburg",
            zipCode: "97072",
          },
          shortcode: null,
          lat: 49.781263,
          lon: 9.932562,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E501064526*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E501064526*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496157",
          description: "Parkplatz P&G",
          address: {
            street: "Hans-Wilhelm-Renkhoff-Straße",
            city: "Marktheidenfeld",
            zipCode: "97828",
          },
          shortcode: null,
          lat: 49.846106,
          lon: 9.618364,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Procter + Gamble",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E370663659*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E370663659*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496152",
          description: "Parkplatz P&G",
          address: {
            street: "Hans-Wilhelm-Renkhoff-Straße",
            city: "Marktheidenfeld",
            zipCode: "97828",
          },
          shortcode: null,
          lat: 49.846069,
          lon: 9.618333,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Procter + Gamble",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E368001004*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E368001004*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496156",
          description: "Parkplatz P&G",
          address: {
            street: "Hans-Wilhelm-Renkhoff-Straße",
            city: "Marktheidenfeld",
            zipCode: "97828",
          },
          shortcode: null,
          lat: 49.84633,
          lon: 9.61851,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Procter + Gamble",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E357385241*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E357385241*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496155",
          description: "Parkplatz P&G",
          address: {
            street: "Hans-Wilhelm-Renkhoff-Straße",
            city: "Marktheidenfeld",
            zipCode: "97828",
          },
          shortcode: null,
          lat: 49.846266,
          lon: 9.618462,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Procter + Gamble",
        },
        {
          name: "WVV Energie <br> E-Ladestation ",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E085274255*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E085274255*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496149",
          description: "Parkplatz P&G",
          address: {
            street: "Hans-Wilhelm-Renkhoff-Straße",
            city: "Marktheidenfeld",
            zipCode: "97828",
          },
          shortcode: null,
          lat: 49.84604,
          lon: 9.618317,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Procter + Gamble",
        },
        {
          name: "WVV Energie <br> E-Ladestation ",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E470560935*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E470560935*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496148",
          description: "Parkplatz P&G",
          address: {
            street: "Hans-Wilhelm-Renkhoff-Straße",
            city: "Marktheidenfeld",
            zipCode: "97828",
          },
          shortcode: null,
          lat: 49.845999,
          lon: 9.618289,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Procter + Gamble",
        },
        {
          name: "WVV Energie <br>  E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E484415341*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E484415341*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496143",
          description: "Parkplatz P&G",
          address: {
            street: "Hans-Wilhelm-Renkhoff-Straße",
            city: "Marktheidenfeld",
            zipCode: "97828",
          },
          shortcode: null,
          lat: 49.846217,
          lon: 9.618435,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Procter + Gamble",
        },
        {
          name: "WVV Energie <br>  E-Ladestation ",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E519965282*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E519965282*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496144",
          description: "Parkplatz P&G",
          address: {
            street: "Hans-Wilhelm-Renkhoff-Straße",
            city: "Marktheidenfeld",
            zipCode: "97828",
          },
          shortcode: null,
          lat: 49.846165,
          lon: 9.618406,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "Procter + Gamble",
        },
        {
          name: "Heizkraftwerk",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2_CABLE",
              evseId: "DE*BDO*E347285287*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
          ],
          serviceTag: "ALF_ACE0195145",
          description: null,
          address: {
            street: "Veitshöchheimerstr. 1",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: "ulo",
          lat: 49.80002016397758,
          lon: 9.9240120503392,
          status: "LOADING",
          published: false,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "Heizkraftwerk",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2_CABLE",
              evseId: "DE*BDO*E332954864*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
          ],
          serviceTag: "ALF_ACE0077006",
          description: null,
          address: {
            street: "Veitshöchheimerstr. 1",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: "hjg",
          lat: 49.80002016397758,
          lon: 9.9240120503392,
          status: "LOADING",
          published: false,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E859826858*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E859826858*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10312238",
          description: "",
          address: {
            street: "Mozartstraße 10",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.784866,
          lon: 9.953968,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E213446041*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E213446041*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ0489A",
          description: "Am Zehnthügel gegenüber Tegut",
          address: {
            street: "Am Zehnthügel 1",
            city: "Estenfeld",
            zipCode: "97230",
          },
          shortcode: null,
          lat: 49.832468,
          lon: 10.006501,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E358148721*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E358148721*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ0490A",
          description: "Am Handelshof direkt vor Burger King",
          address: {
            street: "Am Handelshof 19",
            city: "Würzburg",
            zipCode: "97076",
          },
          shortcode: null,
          lat: 49.818515,
          lon: 9.986064,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E884853076*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E884853076*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10312236",
          description: "",
          address: {
            street: "Jakob-Riedinger-Straße 8",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.783523,
          lon: 9.948161,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E524356717*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E524356717*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10307197",
          description: "Cronthalstraße gegenüber Hausnummer 11",
          address: {
            street: "Cronthalstraße 11",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.775083,
          lon: 9.955834,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E604250945*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E604250945*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10304197",
          description: "Friedenstraße Station 1. direkt am Kreisverkehr",
          address: {
            street: "Friedenstraße 46",
            city: "Würzburg",
            zipCode: "97072",
          },
          shortcode: null,
          lat: 49.7832,
          lon: 9.93692,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E911511565*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E911511565*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10304203",
          description: "Friedenstraße Station 2. direkt am Kreisverkehr",
          address: {
            street: "Friedenstraße 46",
            city: "Würzburg",
            zipCode: "97072",
          },
          shortcode: null,
          lat: 49.7832,
          lon: 9.93692,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E123027526*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E123027526*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10304201",
          description: null,
          address: {
            street: "Crevennastraße 6",
            city: "Würzburg",
            zipCode: "97072",
          },
          shortcode: null,
          lat: 49.793653,
          lon: 9.94828,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E809206642*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E809206642*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10307198",
          description: "Alte Mälzerei",
          address: {
            street: "Frankfurter Straße 81",
            city: "Würzburg",
            zipCode: "97082",
          },
          shortcode: null,
          lat: 49.793995,
          lon: 9.897195,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E950778317*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E950778317*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496154",
          description: "Im Parkhaus",
          address: {
            street: "Leightonstraße 3a",
            city: "Würzburg",
            zipCode: "97074",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.786748695336755,
          lon: 9.98048822374567,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E955792788*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E955792788*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496151",
          description: "Im Parkhaus",
          address: {
            street: "Leightonstraße 3a",
            city: "Würzburg",
            zipCode: "97074",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.786748695336755,
          lon: 9.98048822374567,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E734338962*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E734338962*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496147",
          description: "Im Parkhaus",
          address: {
            street: "Leightonstraße 3a",
            city: "Würzburg",
            zipCode: "97074",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.786748695336755,
          lon: 9.98048822374567,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E879787483*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E879787483*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0496145",
          description: "Im Parkhaus",
          address: {
            street: "Leightonstraße 3a",
            city: "Würzburg",
            zipCode: "97074",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.786748695336755,
          lon: 9.98048822374567,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E517800924*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E517800924*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0533616",
          description: "Im Parkhaus",
          address: {
            street: "Leightonstraße 3a",
            city: "Würzburg",
            zipCode: "97074",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.786748695336755,
          lon: 9.98048822374567,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E849155715*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E849155715*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "2019-45-T-006_WVV",
          description: "Mobilstation Klostergasse",
          address: {
            street: "Ursulinengasse 15",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: "shmkg",
          lat: 49.79129,
          lon: 9.929933,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E358322774*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E358322774*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_22BZ2158A",
          description: "tegut Parkplatz",
          address: {
            street: "Zeppelinstraße 122",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.780324,
          lon: 9.964992,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E600171147*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E600171147*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332125",
          description: "tegut Parkplatz",
          address: {
            street: "Schleifweg 9",
            city: "Würzburg",
            zipCode: "97084",
          },
          shortcode: null,
          lat: 49.722506,
          lon: 9.964818,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E371771476*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E371771476*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10304200",
          description: null,
          address: {
            street: "Steinlein 3A",
            city: "Würzburg",
            zipCode: "97078",
          },
          shortcode: null,
          lat: 49.813367,
          lon: 9.961315,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E502110580*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E502110580*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ4247A",
          description: null,
          address: {
            street: "Am Thomasboden",
            city: "Eibelstadt",
            zipCode: "97246",
          },
          shortcode: null,
          lat: 49.736083,
          lon: 9.989747,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E916966941*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E916966941*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332115",
          description: "Barbarastraße 28",
          address: {
            street: "Barbarastraße 28",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.796092,
          lon: 9.956155,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E884435580*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E884435580*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10304202",
          description: "Barbarastraße 28",
          address: {
            street: "Barbarastraße 28",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.796099,
          lon: 9.956064,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E149435385*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E149435385*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332130",
          description: "Parkplatz-Schulhof",
          address: {
            street: "Schulhof 3",
            city: "Winterhausen",
            zipCode: "97286",
          },
          shortcode: null,
          lat: 49.707541,
          lon: 10.013393,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E199548019*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E199548019*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10308374",
          description: "Wilhelm-Schwinn-Platz",
          address: {
            street: "Stephanstraße 2",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: null,
          lat: 49.789874,
          lon: 9.934643,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E258596018*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E258596018*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10304196",
          description: "Wilhelm-Schwinn-Platz",
          address: {
            street: "Stephanstraße 2",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: null,
          lat: 49.789867,
          lon: 9.934566,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E629489912*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E629489912*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 11000,
            },
          ],
          serviceTag: "ALF_ACE0533609",
          description: "Im Parkhaus",
          address: {
            street: "Haugerglacisstraße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.8011298722695,
          lon: 9.939139797688496,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_014kW_020A",
              plug: "TYP2",
              evseId: "DE*BDO*E270764150*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 14000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_014kW_020A",
              plug: "TYP2",
              evseId: "DE*BDO*E270764150*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 14000,
            },
          ],
          serviceTag: "ALF_ACE0533613",
          description: "Im Parkhaus",
          address: {
            street: "Haugerglacisstraße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.8011298722695,
          lon: 9.939139797688496,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E460179592*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E460179592*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
          ],
          serviceTag: "ALF_ACE0533617",
          description: "Im Parkhaus",
          address: {
            street: "Haugerglacisstraße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.8011298722695,
          lon: 9.939139797688496,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E517353944*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E517353944*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 11000,
            },
          ],
          serviceTag: "ALF_ACE0533618",
          description: "Im Parkhaus",
          address: {
            street: "Haugerglacisstraße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.8011298722695,
          lon: 9.939139797688496,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E109785496*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E109785496*2",
              status: "LOADING",
              isReady: false,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0533619",
          description: "Im Parkhaus",
          address: {
            street: "Haugerglacisstraße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.8011298722695,
          lon: 9.939139797688496,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E923177346*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E923177346*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ4245A",
          description: "Paradeplatz direkt am Dom",
          address: {
            street: "Paradeplatz 1",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: null,
          lat: 49.792957,
          lon: 9.932753,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E344280096*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E344280096*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ4249A",
          description: "Nürnberger Straße",
          address: {
            street: "Nürnberger Straße 57",
            city: "Würzburg",
            zipCode: "97076",
          },
          shortcode: null,
          lat: 49.796359,
          lon: 9.977662,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E773432457*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E773432457*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10330903",
          description: "Parkplatz",
          address: {
            street: "Hinterer Dorfweg 4",
            city: "Sulzfeld am Main",
            zipCode: "97320",
          },
          shortcode: null,
          lat: 49.709517,
          lon: 10.13264,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E369015847*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E369015847*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0533606",
          description: "Im Parkhaus hinter der Schranke",
          address: {
            street: "Pleichertorstraße 5",
            city: "Würzburg",
            zipCode: "97070",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.79914225134066,
          lon: 9.925583774727109,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "Parkhaus CCW 2",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E866433905*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E866433905*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0533607",
          description: "Im Parkhaus nach der Schranke",
          address: {
            street: "Pleichertorstraße 5",
            city: "Würzburg",
            zipCode: "97070",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.79914225134066,
          lon: 9.925583774727109,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "Parkhaus CCW 3",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E945169682*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E945169682*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0533608",
          description: "Im Parkhaus nach der Schranke",
          address: {
            street: "Pleichertorstraße 5",
            city: "Würzburg",
            zipCode: "97070",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.79914225134066,
          lon: 9.925583774727109,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "Parkhaus CCW 4",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E805248849*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E805248849*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
          ],
          serviceTag: "ALF_ACE0533612",
          description: "Im Parkhaus nach der Schranke",
          address: {
            street: "Pleichertorstraße 5",
            city: "Würzburg",
            zipCode: "97070",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 49.79914225134066,
          lon: 9.925583774727109,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E868112978*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E868112978*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0533614",
          description: "Beim Tegut Leinach",
          address: {
            street: "Rathausstraße 33",
            city: "Leinach",
            zipCode: "97274",
          },
          shortcode: null,
          lat: 49.86335475346568,
          lon: 9.804401321549225,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E437468293*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E437468293*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
          ],
          serviceTag: "ALP_23BZ1126E",
          description: "Parkplatz MaxlBäck",
          address: {
            street: "Salvatorstraße 21",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.791927,
          lon: 9.953638,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E057268486*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "DC",
              max_electric_power: 300000,
            },
            {
              charging: false,
              ready: false,
              _id: 2,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E057268486*2",
              status: "LOADING",
              isReady: false,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
          ],
          serviceTag: "ALP_23BZ1120E",
          description: "Parkplatz Seniorenresidenz",
          address: {
            street: "Sonnleite 5",
            city: "Kist",
            zipCode: "97270",
          },
          shortcode: null,
          lat: 49.738786,
          lon: 9.842229,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E823170612*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E823170612*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332126",
          description: null,
          address: {
            street: "Scherenbergstraße 7",
            city: "Würzburg",
            zipCode: "97082",
          },
          shortcode: null,
          lat: 49.79328918457031,
          lon: 9.910357475280762,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E100223564*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E100223564*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10330904",
          description: null,
          address: {
            street: "Wredestraße 9",
            city: "Würzburg",
            zipCode: "97082",
          },
          shortcode: null,
          lat: 49.79511042729069,
          lon: 9.909225478687151,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E386056778*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
          ],
          serviceTag: "ALF_ACE0379209",
          description: "In der Tiefgarage Uni Mensa",
          address: {
            street: "Am Hubland 16",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.782005399321235,
          lon: 9.96803808247586,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_011kW_016A",
              plug: "TYP2",
              evseId: "DE*BDO*E698147425*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 11000,
            },
          ],
          serviceTag: "ALF_ACE0379201",
          description: "In der Tiefgarage Uni Mensa",
          address: {
            street: "Am Hubland 16",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.782005399321235,
          lon: 9.96803808247586,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E403528923*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E403528923*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0255817",
          description: "In der Tiefgarage Uni Mensa",
          address: {
            street: "Am Hubland 16",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.782005399321235,
          lon: 9.96803808247586,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E932702126*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E932702126*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0255767",
          description: "In der Tiefgarage Uni Mensa",
          address: {
            street: "Am Hubland 16",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.782005399321235,
          lon: 9.96803808247586,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E295202826*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E295202826*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0255776",
          description: "In der Tiefgarage Uni Mensa",
          address: {
            street: "Am Hubland 16",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.782005399321235,
          lon: 9.96803808247586,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E365654618*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E365654618*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0255778",
          description: "In der Tiefgarage Uni Mensa",
          address: {
            street: "Am Hubland 16",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.782005399321235,
          lon: 9.96803808247586,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E806420449*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E806420449*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332110",
          description: null,
          address: {
            street: "Versbacher Röthe 48",
            city: "Würzburg",
            zipCode: "97078",
          },
          shortcode: null,
          lat: 49.817426186406585,
          lon: 9.960554639277255,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E647218076*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E647218076*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332109",
          description: null,
          address: {
            street: "Rotkreuzstraße 5",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: null,
          lat: 49.800446655510505,
          lon: 9.92559985254799,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E284732313*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E284732313*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332128",
          description: null,
          address: {
            street: "Oberer Kühlenberg 25",
            city: "Würzburg",
            zipCode: "97078",
          },
          shortcode: null,
          lat: 49.822408804609054,
          lon: 9.969376497724745,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_050kW",
              plug: "CCS",
              evseId: "DE*BDO*E000756058*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 50000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_050kW",
              plug: "CCS",
              evseId: "DE*BDO*E000756058*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 50000,
            },
          ],
          serviceTag: "ALP_100121244",
          description: "Parkplatz am Peuntgraben",
          address: {
            street: "Peuntgraben 1",
            city: "Sulzfeld am Main",
            zipCode: "97320",
          },
          shortcode: null,
          lat: 49.70661,
          lon: 10.132043,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E433498798*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E433498798*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ5188A",
          description: "Neben BMW-Rhein",
          address: {
            street: "Louis-Pasteur-Straße 7",
            city: "Würzburg",
            zipCode: "97076",
          },
          shortcode: null,
          lat: 49.794044127664584,
          lon: 9.997168145440408,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: false,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E896813558*1",
              status: "LOADING",
              isReady: false,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E896813558*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ5189A",
          description: "",
          address: {
            street: "Am Moritzberg 1",
            city: "Rottendorf",
            zipCode: "97228",
          },
          shortcode: null,
          lat: 49.787172,
          lon: 10.03101,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E291412624*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E291412624*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332116",
          description: null,
          address: {
            street: "Am Schwarzberg 16",
            city: "Würzburg",
            zipCode: "97078",
          },
          shortcode: null,
          lat: 49.811019410388035,
          lon: 9.958702104087578,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E099088607*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E099088607*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332104",
          description: null,
          address: {
            street: "Ernst-Reuther-Straße 15",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: null,
          lat: 49.80392188421012,
          lon: 9.941762614086015,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E005343369*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E005343369*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332107",
          description: null,
          address: {
            street: "Ernst-Reuther-Straße 15",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: null,
          lat: 49.80392188421012,
          lon: 9.941762614086015,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E670277134*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E670277134*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332106",
          description: "",
          address: {
            street: "Bismarckstraße 13",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: null,
          lat: 49.80080289661714,
          lon: 9.92879365780246,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E733848424*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E733848424*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332124",
          description: "",
          address: {
            street: "Brunostraße 8",
            city: "Würzburg",
            zipCode: "97082",
          },
          shortcode: null,
          lat: 49.7932585699488,
          lon: 9.90825395701667,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E584338491*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E584338491*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332122",
          description: null,
          address: {
            street: "Weißenburgstraße 39",
            city: "Würzburg",
            zipCode: "97082",
          },
          shortcode: null,
          lat: 49.79745077017574,
          lon: 9.907027164741887,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E611213488*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E611213488*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332114",
          description: "WVV EnergieE-Ladestation Zellerau 7",
          address: {
            street: "Weißenburgstraße 39",
            city: "Würzburg",
            zipCode: "97082",
          },
          shortcode: null,
          lat: 49.79743302390116,
          lon: 9.906878972691842,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E635917368*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E635917368*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332121",
          description: null,
          address: {
            street: "Petrinistraße 33",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: null,
          lat: 49.8017752319761,
          lon: 9.95114833136962,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E858039033*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E858039033*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332129",
          description: "Am Kreisverkehr Estenfelder Straße",
          address: {
            street: "Estenfelder Straße 37",
            city: "Rottendorf",
            zipCode: "97228",
          },
          shortcode: null,
          lat: 49.797606,
          lon: 10.023267,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E615689214*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E615689214*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ1749A",
          description: "Bäckerei Spiegel",
          address: {
            street: "Georg - Heinrich-Appl Straße 20",
            city: "Reichenberg",
            zipCode: "97234",
          },
          shortcode: null,
          lat: 49.688247,
          lon: 9.945176,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E374296800*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E374296800*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ2482A",
          description: "Bäckerei Spiegel",
          address: {
            street: "Georg - Heinrich-Appl Straße 20",
            city: "Reichenberg",
            zipCode: "97234",
          },
          shortcode: null,
          lat: 49.688247,
          lon: 9.945176,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E011704122*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E011704122*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ2483A",
          description: "Bäckerei Spiegel",
          address: {
            street: "Georg - Heinrich-Appl Straße 20",
            city: "Reichenberg",
            zipCode: "97234",
          },
          shortcode: null,
          lat: 49.688247,
          lon: 9.945176,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E734905602*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E734905602*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ1863A",
          description: "Bäckerei Spiegel",
          address: {
            street: "Georg - Heinrich-Appl Straße 20",
            city: "Reichenberg",
            zipCode: "97234",
          },
          shortcode: null,
          lat: 49.688247,
          lon: 9.945176,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_250kW",
              plug: "CCS",
              evseId: "DE*BDO*E290526269*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 250000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_250kW",
              plug: "CCS",
              evseId: "DE*BDO*E290526269*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 250000,
            },
          ],
          serviceTag: "ALP_22BZ3754B",
          description: "Parkplatz Weingartenstraße",
          address: {
            street: "Weingartenstraße 25",
            city: "Würzburg",
            zipCode: "97072",
          },
          shortcode: null,
          lat: 49.784738,
          lon: 9.935208,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E344753264*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E344753264*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0604623",
          description:
            "im Parkhaus; Ladeplätze direkt nach der Schranke rechts (EG)",
          address: {
            street: "Heinrich-von-Bibra-Straße 10",
            city: "Bad Brückenau",
            zipCode: "97769",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 50.30503624466343,
          lon: 9.749382656415838,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E499607884*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E499607884*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0604615",
          description: "im Parkhaus",
          address: {
            street: "Heinrich-von-Bibra-Straße 10",
            city: "Bad Brückenau",
            zipCode: "97769",
          },
          behindBarrier: true,
          shortcode: null,
          lat: 50.30503624466343,
          lon: 9.749382656415838,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E641797140*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E641797140*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ1862A",
          description: "",
          address: {
            street: "Unterdürrbacher Straße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: null,
          lat: 49.803283562472835,
          lon: 9.89607648217629,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E741014574*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E741014574*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ2486A",
          description: "",
          address: {
            street: "Unterdürrbacher Straße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: null,
          lat: 49.803283562472835,
          lon: 9.89607648217629,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E809167098*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E809167098*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ1748A",
          description: "",
          address: {
            street: "Unterdürrbacher Straße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: null,
          lat: 49.803283562472835,
          lon: 9.89607648217629,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E179833742*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E179833742*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_23BZ1864A",
          description: "",
          address: {
            street: "Unterdürrbacher Straße 2",
            city: "Würzburg",
            zipCode: "97080",
          },
          shortcode: null,
          lat: 49.803283562472835,
          lon: 9.89607648217629,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E398984192*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E398984192*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
          ],
          serviceTag: "ALP_23BZ4320B",
          description:
            "Eine Station ist ein „Hybridlader“, sodass auch E-LKW´s laden können. ",
          address: {
            street: "Otto-Hahn-Straße 26",
            city: "Estenfeld",
            zipCode: "97230",
          },
          shortcode: null,
          lat: 49.83960331077005,
          lon: 10.010602419041266,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E267595256*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "DC",
              max_electric_power: 300000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E267595256*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
          ],
          serviceTag: "ALP_23BZ4319B",
          description: "",
          address: {
            street: "Otto-Hahn-Straße 26",
            city: "Estenfeld",
            zipCode: "97230",
          },
          shortcode: null,
          lat: 49.83960331077005,
          lon: 10.010602419041266,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E463370943*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E463370943*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332118",
          description: "",
          address: {
            street: "Schürerstraße 1",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: null,
          lat: 49.79784554686756,
          lon: 9.943918939719662,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E584920580*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E584920580*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332123",
          description: "",
          address: {
            street: "Georg-Eydel-Straße 17",
            city: "Würzburg",
            zipCode: "97082",
          },
          shortcode: null,
          lat: 49.800979068115126,
          lon: 9.917568296314279,
          status: "LOADING",
          published: true,
          accessibilityType: "RESTRICTED",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E046398890*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E046398890*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332108",
          description: "",
          address: {
            street: "Seegartenweg 8",
            city: "Würzburg",
            zipCode: "97084",
          },
          shortcode: null,
          lat: 49.764891744812964,
          lon: 9.949746618016132,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestationen",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E100866491*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E100866491*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332112",
          description: "",
          address: {
            street: "Am Schwarzenberg 11",
            city: "Würzburg",
            zipCode: "97078",
          },
          shortcode: null,
          lat: 49.81066055956437,
          lon: 9.961731940471376,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E988785463*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_150kW",
              plug: "CCS",
              evseId: "DE*BDO*E988785463*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 150000,
            },
          ],
          serviceTag: "ALP_24BZ1517A",
          description: "Gegenüber des SkylineHill Centers",
          address: {
            street: "Leightonstrasse 2",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.787047,
          lon: 9.980141,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E181612166*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E181612166*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0629654",
          description: "",
          address: {
            street: "Mariannhillstraße 6",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.79467544,
          lon: 9.95803097,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie E-Ladestation Frauenland X",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E510889185*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E510889185*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0629655",
          description: "",
          address: {
            street: "Mariannhillstraße 6",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.79467544,
          lon: 9.95803097,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E017527348*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E017527348*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332117",
          description: "Parkplatz Falkenstraße",
          address: {
            street: "Falkenstraße 7",
            city: "Zell",
            zipCode: "97299",
          },
          shortcode: null,
          lat: 49.814854,
          lon: 9.863739,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E167989967*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E167989967*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332113",
          description: "",
          address: {
            street: "Fahrstraße 1",
            city: "Zell",
            zipCode: "97299",
          },
          shortcode: null,
          lat: 49.808607,
          lon: 9.873017,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation ",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E771282543*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E771282543*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332119",
          description: "",
          address: {
            street: "Weingartenstraße 1",
            city: "Würzburg",
            zipCode: "97072",
          },
          shortcode: null,
          lat: 49.786571723929036,
          lon: 9.936317028310059,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation ",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E180351448*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E180351448*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
          ],
          serviceTag: "ALP_23BZ8466B",
          description: "Direkt beim Autohaus Schürer",
          address: {
            street: "Nürnberger Straße 107",
            city: "Würzburg",
            zipCode: "97076",
          },
          shortcode: null,
          lat: 49.798475,
          lon: 9.990487,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation ",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E192530084*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E192530084*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
          ],
          serviceTag: "ALP_23BZ8472B",
          description: "Direkt beim Autohaus Schürer",
          address: {
            street: "Nürnberger Straße 107",
            city: "Würzburg",
            zipCode: "97076",
          },
          shortcode: null,
          lat: 49.798483,
          lon: 9.990567,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E498762855*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E498762855*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "DC",
              max_electric_power: 300000,
            },
          ],
          serviceTag: "ALP_23BZ8468B",
          description: "",
          address: {
            street: "Wallgasse 4",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: null,
          lat: 49.799545,
          lon: 9.936764,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: true,
              ready: false,
              _id: 1,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E874880323*1",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "DC",
              max_electric_power: 300000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_300kW",
              plug: "CCS",
              evseId: "DE*BDO*E874880323*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
          ],
          serviceTag: "ALP_23BZ8283B",
          description: "",
          address: {
            street: "Wallgasse 4",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: null,
          lat: 49.799545,
          lon: 9.936764,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation ",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "DC_050kW",
              plug: "CCS",
              evseId: "DE*BDO*E230740281*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 50000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "DC_050kW",
              plug: "CCS",
              evseId: "DE*BDO*E230740281*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 50000,
            },
          ],
          serviceTag: "ALP_100130493",
          description: "",
          address: {
            street: "Höchberger Straße 28",
            city: "Würzburg",
            zipCode: "97082",
          },
          shortcode: null,
          lat: 49.792686,
          lon: 9.9149238,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E569748039*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E569748039*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0533605",
          description: "",
          address: {
            street: "Höchberger Straße 28",
            city: "Würzburg",
            zipCode: "97082",
          },
          shortcode: null,
          lat: 49.792686,
          lon: 9.9149238,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E337598677*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: true,
              ready: false,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E337598677*2",
              status: "LOADING",
              isReady: false,
              isCharging: true,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10367931",
          description: "",
          address: {
            street: "Lortzingstraße 1",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.7886099,
          lon: 9.95592,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie  <br> E-Ladestation ",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E297787246*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E297787246*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10332111",
          description: null,
          address: {
            street: "Ludwigkai 9",
            city: "Würzburg",
            zipCode: "97072",
          },
          shortcode: null,
          lat: 49.78203896410447,
          lon: 9.92959356637505,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: false,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie  <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E473488699*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E473488699*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0629652",
          description: "Parkplatz Hotel",
          address: {
            street: "Am Galgenberg 49",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.787497,
          lon: 9.9637863,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: 'Ladeplatz "WVV Energie E-Ladestation XI',
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E868834324*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E868834324*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0604622",
          description: "Parkplatz Hotel",
          address: {
            street: "Am Galgenberg 49",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.787497,
          lon: 9.9637863,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: 'Ladeplatz "WVV Energie E-Ladestation XI',
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E867225451*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E867225451*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0629649",
          description: "Parkplatz Hotel",
          address: {
            street: "Am Galgenberg 49",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.787497,
          lon: 9.9637863,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: 'Ladeplatz "WVV Energie E-Ladestation XI',
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E483157819*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E483157819*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ALF_ACE0629659",
          description: "Parkplatz Hotel",
          address: {
            street: "Am Galgenberg 49",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.787497,
          lon: 9.9637863,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie <br> E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: true,
              _id: 1,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E561486334*1",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
            {
              charging: false,
              ready: true,
              _id: 2,
              powerInfo: "AC_022kW_032A",
              plug: "TYP2",
              evseId: "DE*BDO*E561486334*2",
              status: "LOADING",
              isReady: true,
              isCharging: false,
              power_type: "AC",
              max_electric_power: 22000,
            },
          ],
          serviceTag: "ABL_10367928",
          description: "Am Friedhof",
          address: {
            street: "Ochsenfurter Straße 4",
            city: "Eibelstadt",
            zipCode: "97246",
          },
          shortcode: null,
          lat: 49.722327,
          lon: 10.003678,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie E-Ladestation Löwenbrücke",
          circuits: [],
          serviceTag: "ABL_10367932",
          description: null,
          address: {
            street: "An der Löwenbrücke 2",
            city: "Würzburg",
            zipCode: "97070",
          },
          shortcode: null,
          lat: 49.78658120074041,
          lon: 9.92821741250067,
          status: "LOADING",
          published: true,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie E-Ladestation",
          circuits: [
            {
              charging: false,
              ready: false,
              _id: 1,
              powerInfo: "DC_300kW",
              plug: "CCS1",
              evseId: "DE*BDO*E519727142*1",
              status: "LOADING",
              isReady: false,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
            {
              charging: false,
              ready: false,
              _id: 2,
              powerInfo: "DC_300kW",
              plug: "CCS1",
              evseId: "DE*BDO*E519727142*2",
              status: "LOADING",
              isReady: false,
              isCharging: false,
              power_type: "DC",
              max_electric_power: 300000,
            },
          ],
          serviceTag: "ALP_23BZ1125E",
          description: "Am Kappellenberg",
          address: {
            street: "Am Kappelenberg 1",
            city: "Eibelstadt",
            zipCode: "97246",
          },
          shortcode: null,
          lat: 49.731007,
          lon: 9.993657,
          status: "LOADING",
          published: false,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
        {
          name: "WVV Energie E-Ladestation",
          circuits: [],
          serviceTag: "ALP_100137517",
          description: null,
          address: {
            street: "Rottendorfer Straße 67",
            city: "Würzburg",
            zipCode: "97074",
          },
          shortcode: null,
          lat: 49.790353,
          lon: 9.967832,
          status: "LOADING",
          published: false,
          accessibilityType: "FREEPUBLIC",
          hours: {
            twentyfourseven: true,
            regular_hours: null,
          },
          operatorName: "WVV",
        },
      ],
    },
  }) as ChargingStationsResponse;
